import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlayIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1000 1000",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M0 500Q0 357 62.5 243 125 129 237.5 64.5 350 0 496 0 641 0 756 63 871 126 935.5 239 1000 352 1000 496 1000 652 937 765.5 874 879 761 939.5 648 1000 500 1000 353 1000 239.5 941 126 882 63 769.5 0 657 0 500ZM648 527Q660 519 663.5 512.5 667 506 667 497 667 488 663.5 481.5 660 475 648 468L439 340Q422 330 410 330 385 330 385 368L385 633Q385 650 391.5 658.5 398 667 410 667 421 667 436 658Z" })
});
export default SvgPlayIcon;
